exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".bulk-archive-1{fill:none}\n.bulk-archive-2{fill:#e6e6e6}\n.bulk-archive-3{fill:#1e4e69}\n.bulk-archive-4{fill:#fff}", ""]);
